import React, { Component } from 'react';
import Button from 'react-bootstrap/lib/Button';
import './Header.css';
import API from '../../API/Api';
import { Modal } from 'react-bootstrap';
import { Link, Redirect } from 'react-router-dom'
import services from './../../services/index'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons'
import Spinner from './../spinner/Spinner'
import GLOBAL from "../../global"
import { IoIosMenu } from "react-icons/io"
import { FaUser } from "react-icons/fa"
import { FiMapPin } from "react-icons/fi"
import { withRouter } from 'react-router-dom'

import MenuItens from "../../components/menuitens"

import { isEmpty } from "lodash"
import { Button as ButtonUI } from '@material-ui/core';


import { connect } from "react-redux";
import { bindActionCreators } from "redux"
import * as Actions from "../../store/actions"
import logo from "./logo.png"
class Header extends Component {

  static defaultProps = {
    srcImage: logo,
    srcPofile: 'assets/user.png',

    logado: false,
    where: 'cadastrocliente',
    user: {},
    nameClient: '',
    teste: false,

  }

  state = {
    nameClient: '',
    userObj: {},
    showMenu: false,
    display: 0,
    showLogin: false,
    loading: false,
    redirec: false,
    email: '',
    senha: '',
    colorHeader: GLOBAL.COLORS.primary,
    heightMenuMobile: 0,
    adressChoice: false,
    adressToChoice: [],
    indexPrincipalAdress: 0,
    logado: false,
    principalAdress: {}
  }



  componentDidMount() {
    if (this.props.estouNaMesa) return;
    const isIn = services.getLogado();
    this.setState({ logado: isIn });
    if (isIn) {
      const user = services.getUser();
      if (!isEmpty(user)) {
        if (!isEmpty(this.props.rdUser)) {
          this.props.setUserLogado(user.dados_cli);
          this.props.setAdressUser(user.enderecos);
        }
      }
    }

  }





  handleSair = (e) => {
    localStorage.removeItem('@systemdelivery:dataclient');
    services.setLogado(false);

    this.setState({ logado: false })

    // Hack por conta do comportamento do smartphone;
    setTimeout(() => {
      this.props.history.push('/CadastroCliente');
      this.props.history.push('/');
    }, 400)
  }



  showMenu = () => {
    this.setState({ display: 1 }, () => {
      document.addEventListener('click', this.closeMenu);
    });
  }

  closeMenu = () => {
    this.setState({ display: 0 }, () => {
      document.removeEventListener('click', this.closeMenu)
    });
  }


  makeLogin = () => {
    this.setState({ showLogin: true })
  }

  closeLogin = () => {
    this.setState({ showLogin: false });
  }



  loading = (status) => {
    if (status) {
      this.setState({ loading: true })
    } else {
      this.setState({ loading: false });
    }
  }


  handleBtns = () => {

    if (this.props.isCardapio) return;

    return (
      <>
        <Button onClick={this.makeLogin} className="btn-header">Login</Button>
        <Link to="/CadastroCliente" >
          <Button className="btn-header" style={{ marginRight: 10 }}>Cadastre-se</Button>
        </Link>
      </>
    );
  }


  redireciona = () => {
    if (this.props.where != 'principal') {
      //this.setState({ redirec: true })
      this.props.history.push('/');
    } else {
      // HackMobile
      this.props.history.push('/CadastroCliente');
      this.props.history.push('/');
    }

  }

  handleAllInputs = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }




  logaCliente = async () => {
    this.loading(true);

    const dataLogin = { email: this.state.email, password: this.state.senha }

    try {
      let headers = { "Content-Type": " application/json" }
      const response = await API.post('login', dataLogin, { headers: headers });

      this.loading(false);

      if (response.status === 200) {

        this.props.setUserLogado(response.data.dados_cli);
        this.props.setAdressUser(response.data.enderecos);
        services.setUser(JSON.stringify(response.data))

        services.setLogado(true);
        this.setState({ logado: true, showLogin: false });
        // Hack por conta do comportamento do smartphone;
        setTimeout(() => {
          this.props.history.push('/CadastroCliente');
          this.props.history.push('/');
        }, 400)
      } else {
        alert('E-mail ou Senha Inválido')
      }
    } catch (error) {
      this.loading(false);
      if (error) {
        if (error.response.status === 401) {
          alert('Senha inválida');
        } else if (error.response.status === 404) {
          alert('Usuário não encontrado');
        } else {
          alert('Ops... Algo não deu certo. Vamos tentar novamente !');
        }
      } else {
        alert('Ops... Algo não deu certo. Vamos tentar novamente !');
      }
    }
  }






  handleEsqueciSenha = async (e) => {
    e.preventDefault();
    if (this.state.email) {
      let response = await services.enviaLinkEsqueciSenha(this.state.email);
      if (!response.err) {
        alert(`Enviamos um E-mail para ${this.state.email} com as instrução para criação de uma nova senha.`);
      } else {
        alert('O E-mail informado não está em nosso sistema');
      }
    } else {
      alert('Por favor, informe o e-mail no campo e-mail.');
    }
  }


  handleKeyUp = (e) => {
    if (e.keyCode === 13) this.logaCliente();
  }



  toggleMenu = () => {
    this.setState({ heightMenuMobile: this.state.heightMenuMobile > 50 ? 0 : 200 });
  }





  isLoggedIn = () => {
    if (this.props.estouNaMesa) return;
    if (this.state.logado) {
      return (
        <>
          <div className="profileUl hidden-xs" onClick={this.showMenu}>

            <p className="text-welcome">Olá <strong>{this.props.rdUser.nome_completo}</strong></p>
            <FaUser color={"#fff"} size={30} />

            <div className="optionsUser" style={{ display: this.state.display === 0 ? 'none' : 'block' }}>
              <ul>
                <li><Link to="/Perfil">Perfil</Link></li>
                <li><Link to="/HistoricoPedidos">Meus Pedidos</Link></li>

                <li><a href="#" onClick={this.handleSair}>Sair</a></li>
              </ul>
            </div>
          </div>
        </>
      );
    } else {
      return this.handleBtns()
    }
  }





  openAdressSelect = () => {
    const user = services.getUser();
    this.setState({ adressToChoice: user.enderecos, adressChoice: true });
  }







  render() {

    return (
      <>
        <div className="header" style={{ background: this.state.colorHeader, transition: 'all .7s' }}>
          <div className="container">
            <div className={!this.props.isCardapio ? "flexLayout" : "flexLayoutCardapio"}>

              <div className="box-img-logo hidden-xs">
                <Link to={this.props.isCardapio ? "/cardapio" : "/"} >
                  <img src={this.props.srcImage} className="img-logo" alt="logo" />
                </Link>
              </div>

              {this.props.isCardapio && <h1 id="cardapioLabel">Cardápio</h1>}

              {this.state.logado ? (
                <div
                  style={{
                    display: 'flex',
                    alignItems: "center",
                    flexDirection: "row",
                    justifyContent: "center",
                    padding: 8
                  }}
                >
                </div>
              ) : ''
              }

              {!this.props.isCardapio && <div style={{ flexDirection: 'row', display: 'flex' }}>
                {this.isLoggedIn()}
              </div>
              }

            </div>
          </div>

          {
            this.state.logado && !this.props.isCardapio ? (
              <div className="visible-xs">
                <ButtonUI className="pull-right btnMenuMobile" onClick={this.toggleMenu}>
                  <IoIosMenu size="35" color="#fff" />
                </ButtonUI>
              </div>
            ) : ''
          }



          {!this.props.isCardapio && <div className="menuMobile visible-xs" style={{ height: this.state.heightMenuMobile, background: GLOBAL.COLORS.primary }}>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/Perfil">Perfil</Link></li>
              <li><Link to="/HistoricoPedidos">Meus Pedidos</Link></li>
              <li><a href="#" onClick={this.handleSair}>Sair</a></li>
            </ul>
          </div>}


          <Modal show={this.state.showLogin} onHide={this.closeLogin} className="tetete">
            <Modal.Header style={{ background: this.state.colorHeader }} closeButton>
              <Modal.Title style={{ color: '#fff', fontFamily: "'Arima Madurai', cursive !important" }}>Login</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ background: '#fff' }}>
              <div className="form-group">
                <input type="text" className="form-control yellowOutline" placeholder="E-mail" name="email" value={this.state.email} onChange={this.handleAllInputs} />
              </div>

              <div className="form-group">
                <input type="password" className="form-control yellowOutline" onKeyUp={this.handleKeyUp} placeholder="Senha" name="senha" value={this.state.senha} onChange={this.handleAllInputs} />
              </div>
              {!this.state.loading ? <button onClick={this.logaCliente}
                className="btn btn-primary  btnCadastrar">ENTRAR</button> : <Spinner size="less" />
              }
            </Modal.Body>
            <Modal.Footer style={{ background: '#fff' }}>
              <a href="#" onClick={this.handleEsqueciSenha}>Esqueci minha senha</a>
            </Modal.Footer>
          </Modal>

          {this.props.showMenuItens && <MenuItens
            items={this.props.items}
            selectedIndex={this.props.selected}
            onClickItem={this.props.onClickItem}
            className="fixedMenu"
            fromCardapio={this.props.isCardapio}
            fromTable={this.props.isFromTable}
            objTable={this.props.objTable}
            fromTable={this.props.estouNaMesa}
          />}
        </div>

      </>

    );
  }


}


const mapStateToProps = state => ({
  rdUser: state.user
})

const mapDispathToPros = dispatch => bindActionCreators(Actions, dispatch)

export default withRouter(connect(mapStateToProps, mapDispathToPros)(Header))

